/**
 * Badge — pastille statut/etiquette compact.
 *
 * 6 variants alignes sur la palette sgraphic (encre + rouge + papier — pas
 * de vert/bleu/orange/violet) :
 *   default  · contour encre, fond papier
 *   success  · encre + dot
 *   info     · encre + dot
 *   warning  · encre700
 *   danger   · rouge sang
 *   accent   · rouge editorial
 *   solid    · fond encre plein
 *
 *   <Badge variant="success" dot>Publie</Badge>
 *   <Badge variant="danger">Erreur</Badge>
 */
import type { ReactNode } from 'react'

export type BadgeVariant =
  'default' | 'success' | 'info' | 'warning' | 'danger' | 'accent' | 'solid'
export type BadgeSize = 'sm' | 'md'

interface BadgeProps {
  variant?: BadgeVariant
  size?: BadgeSize
  /** Petit point en tete (pour les statuts en cours / publies / etc.). */
  dot?: boolean
  children: ReactNode
  className?: string
  title?: string
}

export default function Badge({
  variant = 'default',
  size = 'md',
  dot = false,
  children,
  className,
  title,
}: BadgeProps) {
  const classes = [
    'ui-badge',
    variant !== 'default' && `ui-badge--${variant}`,
    size === 'sm' && 'ui-badge--sm',
    className,
  ]
    .filter(Boolean)
    .join(' ')
  return (
    <span className={classes} title={title}>
      {dot && <span className="ui-dot" aria-hidden="true" />}
      {children}
    </span>
  )
}
